/** Always true; CartItemList still reads it. */
export default function useCartItemV2Enabled(): boolean {
  return true;
}
